"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixViewMode = exports.RLOMode = void 0;
var RLOMode;
(function (RLOMode) {
    RLOMode["login"] = "login";
    RLOMode["signup"] = "signup";
})(RLOMode = exports.RLOMode || (exports.RLOMode = {}));
// Wix JS SDK does not enforce viewMode to be any of these values, so it's not
// recommended to use this type if you just want to forward viewMode. Use string
// for storing the value and check for particular case against this enum.
var WixViewMode;
(function (WixViewMode) {
    WixViewMode["PREVIEW"] = "preview";
    WixViewMode["EDITOR"] = "editor";
    WixViewMode["SITE"] = "site";
    WixViewMode["VIEWER_SEO"] = "viewer-seo";
})(WixViewMode = exports.WixViewMode || (exports.WixViewMode = {}));
//# sourceMappingURL=js-sdk.js.map